import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ebe4fbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrapper" }
const _hoisted_2 = { class: "df mt-15" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "case-wrapper__item" }
const _hoisted_6 = { class: "case--info" }
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = { class: "selector" }
const _hoisted_9 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "checker unchecked"
}
const _hoisted_13 = { class: "case-wrapper__item" }
const _hoisted_14 = { class: "case--info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "selector" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "checker unchecked" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_item_case = _resolveComponent("item-case")!
  const _component_app_skeleton_case = _resolveComponent("app-skeleton-case")!
  const _component_app_skeleton_rect = _resolveComponent("app-skeleton-rect")!
  const _component_app_case_view_pop_up = _resolveComponent("app-case-view-pop-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, { customTitle: _ctx.title }, {
      bottom: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_app_search, {
              modelValue: _ctx.driveStore.search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.driveStore.search) = $event)),
              onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.search = ''))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["mrl-16 icon", _ctx.driveStore.isGridPhotoView ? 'icon-tiles-2' : 'icon-tiles']),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.driveStore.switchPhotoView && _ctx.driveStore.switchPhotoView(...args)))
          }, null, 2)
        ])
      ]),
      "top-left": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('cancel')), ["prevent"])),
          class: "back-link"
        }, _toDisplayString(_ctx.$localize('case.selector.popup.backtext')), 1)
      ]),
      "top-right": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doneAction && _ctx.doneAction(...args)), ["prevent"])),
          class: _normalizeClass([{ disabled: !_ctx.selectedCase }, "back-link"])
        }, _toDisplayString(_ctx.$localize('case.selector.popup.done.button')), 3)
      ]),
      _: 1
    }, 8, ["customTitle"]),
    _createElementVNode("div", {
      ref: "scroller",
      onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
      class: "case-wrapper scroll"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cases, (iCase) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "df",
          key: iCase.id!,
          onClick: ($event: any) => (_ctx.selectedCase = iCase)
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_item_case, {
              iCase: iCase,
              hideTitle: "",
              onClick: _withModifiers(($event: any) => (_ctx.setPreviewCase(iCase)), ["stop"])
            }, null, 8, ["iCase", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(iCase.title), 1),
            _createElementVNode("p", null, _toDisplayString(iCase.description || _ctx.$localize('case.selector.popup.without.description')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (iCase.id === _ctx.selectedCase?.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : (_openBlock(), _createElementBlock("div", _hoisted_12))
          ])
        ], 8, _hoisted_4))
      }), 128)),
      (_ctx.isPageLoading || _ctx.dataLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(9, (n) => {
            return _createElementVNode("div", {
              class: "df",
              key: n
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_app_skeleton_case, { hideTitle: "" })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_app_skeleton_rect, { style: {"margin-bottom":"5px"} }),
                _createVNode(_component_app_skeleton_rect)
              ]),
              _hoisted_15
            ])
          }), 64))
        : _createCommentVNode("", true)
    ], 544),
    (_ctx.previewCase.show)
      ? (_openBlock(), _createBlock(_component_app_case_view_pop_up, {
          key: 0,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.previewCase.show = false)),
          onDone: _ctx.selectCase,
          caseId: _ctx.previewCase.id,
          title: _ctx.previewCase.title,
          "photo-skeletons": _ctx.previewCase.photosAmount,
          "file-skeletons": _ctx.previewCase.filesAmount
        }, null, 8, ["onDone", "caseId", "title", "photo-skeletons", "file-skeletons"]))
      : _createCommentVNode("", true)
  ]))
}